import { Component } from 'react';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { ExpandingTextArea } from 'foundations-components/transitional/components/ExpandingTextArea';
import { Box } from 'foundations-components/transitional/components/Box';
import { DEFAULT_ARTICLE_NAME, getArticleNamePlaceholder } from '../../../utils/articleUtils';
import MultilineCharacterCounter from './MultilineCharacterCounter';
import { Small as FoundationsSmall } from 'foundations-components/transitional/components/Small';
import { jsx as _jsx } from "react/jsx-runtime";
const I18nKey = key => `knowledgeContentUI.edit.fields.title.${key}`;
class TitleEditor extends Component {
  constructor(...args) {
    super(...args);
    this.preventDefaultEvent = e => {
      e.preventDefault();
    };
  }
  render() {
    const value = this.props.value === DEFAULT_ARTICLE_NAME ? '' : this.props.value;
    return /*#__PURE__*/_jsx("div", {
      onDragEnter: this.preventDefaultEvent,
      onDragOver: this.preventDefaultEvent,
      onDrop: this.preventDefaultEvent,
      children: /*#__PURE__*/_jsx(Box, {
        inlineSize: "688px",
        marginBlockStart: "800",
        marginInlineStart: "auto",
        marginInlineEnd: "auto",
        children: /*#__PURE__*/_jsx(FormControl, {
          label: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: I18nKey('label_jsx'),
            elements: {
              Small: FoundationsSmall
            }
          }),
          required: true,
          children: /*#__PURE__*/_jsx(MultilineCharacterCounter, {
            "data-test-id": "article-title",
            disabled: this.props.disabled,
            inputRef: this.props.inputRef,
            maxLength: 200,
            maxLengthWarningThreshold: 10,
            onBlur: this.props.onBlur,
            onChange: this.props.onChange,
            placeholder: getArticleNamePlaceholder(),
            textAreaComponent: ExpandingTextArea,
            value: value
          })
        })
      })
    });
  }
}
export default TitleEditor;